import { render, staticRenderFns } from "./form_job.vue?vue&type=template&id=95f31828&scoped=true&"
import script from "./form_job.vue?vue&type=script&lang=js&"
export * from "./form_job.vue?vue&type=script&lang=js&"
import style0 from "./form_job.vue?vue&type=style&index=0&id=95f31828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f31828",
  null
  
)

export default component.exports